import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormPentagon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-pentagon"><path d="M12 2.25L21.2728 8.98708L17.7309 19.8879H6.26909L2.7272 8.98708L12 2.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFormPentagon;
